import style from "./AppDrugPage.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";

export const DrugSearchRecent = ( {onClearSearch, recentSearches }) => {
  const drugSearches = recentSearches?.drugSearches;

  return (
    <div
      className={classNames("size-14", style.drugSuggestionsContainer)}
      data-testid="drugsearch-tabs-page"
    >
      <div className={classNames(style.recentHeaderContainer)}>
        <h2 className={classNames("size-18", "bold ")}>Recent Searches</h2>
        <span
          className={classNames(style.clearSearch)}
          aria-label={"Clear Recent Search"}
          role={"button"}
          onClick={onClearSearch}
        >
          Clear history
        </span>
      </div>
      {drugSearches && drugSearches.length > 0 ? (
        <ul className={style.recentSearchesList}>
          {drugSearches.map((search, index) => (
            <li key={index} className={style.recentSearchItem}>
              <Link to={`/app/drugLanding?search=${search}`}>{search}</Link>
            </li>
          ))}
        </ul>
      ) : (
        <div className={style.noRecentSearchs}>
          You have no recent searches.
        </div>
      )}
    </div>
  );
};

DrugSearchRecent.propTypes = {
  recentSearches: PropTypes.shape({
    drugSearches: PropTypes.arrayOf(PropTypes.string)
  }),
  clearSearchHistory: PropTypes.func,
};
